"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.aggregationIntervalHelperByValueTypeId = void 0;
const _aggregation_helpers_1 = require("../../_aggregation_helpers");
exports.aggregationIntervalHelperByValueTypeId = {
    almondHullSplit: _aggregation_helpers_1.unaggregatedOnlyAggregationIntervalHelper,
};
//# sourceMappingURL=almond_hull_split.js.map